import { create } from "zustand";

type UiStore = {
  newRequestsSpotlightOpen: boolean;
  setNewRequestsSpotlightOpen: (open: boolean) => void;
  acknowledgeNewRequestsSpotlight: () => void;
};

/**
 * Client-only UI flags (not server state).
 * Global product modals (verification, intent, etc.) stay in AppLayout openers.
 */
export const useUiStore = create<UiStore>((set) => ({
  newRequestsSpotlightOpen: false,
  setNewRequestsSpotlightOpen: (open) => set({ newRequestsSpotlightOpen: open }),
  acknowledgeNewRequestsSpotlight: () => set({ newRequestsSpotlightOpen: false }),
}));
